export default __webpack_public_path__ + "static/media/icon_onboarding.f8a71aa0.svg";